import { SWITCH_CASH_FLOW_MODAL } from '../types';

const initialState = {
  data: {},
  showModal: false,
};

// switch initial state as cashFlowModalState and export it export cashFlowModalState

const cashFlowModalReducer = (state = initialState, action) => {
  switch (action.type) {
    case SWITCH_CASH_FLOW_MODAL:
      return {
        data: action.payload,
        showModal: !state.showModal,
      };

    default:
      return state;
  }
};

export default cashFlowModalReducer;
